import { Component, Input, OnInit } from '@angular/core';
import { CellData, CellUtil, ComponentData } from '@ddt-web/data-service';
import { PartnerConstants } from '@ddt-web/user-data';
import * as get from 'lodash/get';
import * as includes from 'lodash/includes';

@Component({
	selector: 'pi-unsupported-sleeves',
	templateUrl: './unsupported-sleeves.component.html',
	styleUrls: ['./unsupported-sleeves.component.scss']
})
export class UnsupportedSleevesComponent implements OnInit {

	@Input() public data: ComponentData;
	@Input() public singleErrorView: boolean;

	public sleeveData: any[] = [];

	public ngOnInit(): void {
		this.sleeveData = this.getUnsupportedSleeves();
	}

	private getUnsupportedSleeves(): any[] {
		const portfolioSecuritiesTab = this.data.getTabById('portfolio.securities');
		const cells: CellData[][] = get(portfolioSecuritiesTab, 'tableData[0].cells', []);

		return cells
			.reduce((sleeveData: any, cellDataArray) => {
				const positionTypeCellData = CellUtil.getById(cellDataArray, 'positionType');
				const originPlatformCellData = CellUtil.getById(cellDataArray, 'originPlatform');

				const originPlatform = get(originPlatformCellData, 'formattedValue');
				const originPlatformType = get(originPlatform, 'type');
				const originPlatformName = get(originPlatform, 'name');

				// check if the child is invalid and a sleeve
				const isInvalidSleeve = get(positionTypeCellData, 'formattedValue') === 'INVALID' &&
					includes(PartnerConstants.PARTNER_SLEEVE_TYPES, originPlatformType);

				if (isInvalidSleeve) {
					sleeveData.push({ 'name': originPlatformName, 'issue': originPlatformType });
				}

				return sleeveData;
			}, []);
	}
}
